
export const medicalInvoiceData = {
  company: {
    name: "Radiance MedSpa",
    tagline: "Where Beauty Meets Science.",
    address: "502 Green Residency, MG Road, Pune, Maharashtra, 411001",
    phone: "+91 98765 43210",
    email: "contact@radiancemedspa.in"
  },
  invoice: {
    number: "INV-2026-045",
    date: "15 Jan 2026",
    dueDate: "22 Jan 2026",
    preparedBy: "Dr. Neha Kapoor",
    paymentTerms: "Due on receipt"
  },
  client: {
    name: "Anjali Sharma",
    address: "Flat 502, Green Residency, MG Road, Pune, Maharashtra, 411001"
  },
  items: [
    { months: 1, desc: "Laser Skin Treatment", rate: 5000 },
    { months: 1, desc: "Facial Therapy", rate: 1500 },
    { months: 1, desc: "Botox Injection", rate: 8000 },
    { months: 1, desc: "Chemical Peel", rate: 2500 },
    { months: 1, desc: "Skin Tightening", rate: 4000 },
    { months: 1, desc: "PRP Therapy", rate: 6000 }
  ],
  gstRate: 10 // 10% GST
};
